
import moment from "moment";
import * as ContactUtils from "./ContactUtils";
require("moment/min/locales.min");

export { getContactById } from "./ContactUtils";

export const isHubChannelExist = (channel) => {
    if (!channel) {
        return false;
    }
    return channel.data ? true : false;
}

export const isSubscribed = (channel) => {
    if (!channel) {
        return false;
    }
    return channel.data ? channel.data.subscribed : false;
}

export const getName = (channel) => {
    if (!channel) {
        return "";
    }

    return channel.name;
}

export const getTopic = (channel) => {
    if (!channel) {
        return "";
    }

    return channel.topic;
}

export const getCategory = (channel) => {
    if (!channel) {
        return "";
    }

    return channel.category;
}

export const getCreationDate = (channel) => {
    if (!channel) {
        return "";
    }

    let createDate = moment(channel.creationDate).format('YYYY-MM-DD, h:mm');
    return createDate;
}

export const lastUpdated = (channel, intl = "en") => {
    moment.locale(intl.locale);
    
    if (!channel) {
        return "";
    }

    let fromDate = moment(channel.first);
    let from = moment(fromDate).fromNow();

    return from;
}


export const getCreator = (contact) => {
    return ContactUtils.getDisplayName(contact);
}

export const getPublisherName = (item, contactList) => {
    const contact = ContactUtils.getContactByJid(item.from, contactList);
    return ContactUtils.getDisplayName(contact);
}

export const getItemDate = (item) => {
    if (!item) {
        return ""
    }

    let createDate = moment(item.timestamp).format('YYYY MMMM DD, h:mm a');
    return createDate;
}

export const getItemTitle = (item) => {
    if (!item) {
        return ""
    }

    return item.title;
}

export const getAvatar = (item, contactList) => {
    const contact = ContactUtils.getContactByJid(item.from, contactList);
    return ContactUtils.getAvatar(contact);
}